import { render } from "./JoinSection.vue?vue&type=template&id=7d36beec"
import script from "./JoinSection.vue?vue&type=script&lang=js"
export * from "./JoinSection.vue?vue&type=script&lang=js"

import "./JoinSection.vue?vue&type=style&index=0&id=7d36beec&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__